import React from 'react'
import { bool, string } from 'prop-types'

import styles from './Title.module.scss'
import Surround from '../Surround'
import Type from '../Type'
import ButtonStandard from '../ButtonStandard'
import classNames from 'classnames'
import Hide from '../Hide'
import Icon from '@/component/Primitive/Icon'

const Title = ({
  title,
  ctaLabel,
  ctaUrl,
  to,
  bordered,
  as = 'h2',
  inverse,
  className,
  isLarge
}) => (
  <Surround
    bordered={bordered}
    borderWidth="thick"
    borderColor={isLarge ? 'grey' : 'darkGrey'}
    className={classNames(
      styles.TitleWrapper,
      inverse && styles.inverse,
      className
    )}
  >
    <div className={styles.TitleInner}>
      <Type
        themed
        className={styles.Title}
        as={as}
        size={['heading7', isLarge ? 'heading1' : 'heading5']}
        weight="bold"
      >
        {title}
      </Type>
      {ctaLabel && ctaUrl && (
        <ButtonStandard
          inverse={inverse}
          outline
          to={to || '/section'}
          as={ctaUrl}
          size="small"
        >
          <span className={styles.TitleButtonInner}>
            <Hide below="desktop">{ctaLabel}</Hide>
            <Icon
              width="7"
              height="12"
              className={styles.TitleButtonInnerIcon}
              type="arrow-right"
            />
          </span>
        </ButtonStandard>
      )}
    </div>
  </Surround>
)

Title.propTypes = {
  title: string.isRequired,
  bordered: string,
  inverse: bool,
  isLarge: bool,
  as: string,
  ctaLabel: string,
  ctaUrl: string,
  to: string,
  className: string
}

export default Title
